import { normalizeCptCodes } from './modalityPlaceOfService';

export type SessionBillingLineItem = {
  code_id: string;
  modifiers?: string[];
  units?: number;
};

export type SessionBillingPayload = {
  place_of_service?: string | null;
  line_items?: SessionBillingLineItem[];
};

type SessionBillingCarrier = {
  session_billing?: SessionBillingPayload | null;
  scheduled_billing_defaults?: SessionBillingPayload | null;
  place_of_service?: string | null;
  cpt_codes?: string[] | null;
};

const toCptCodeId = (code: string): string => `CPT:${code}`;

const getSessionBilling = (
  value: SessionBillingCarrier | null | undefined,
): SessionBillingPayload | null =>
  value?.session_billing ?? value?.scheduled_billing_defaults ?? null;

export const buildSessionBillingPayload = ({
  placeOfService,
  cptCodes,
}: {
  placeOfService?: string | null;
  cptCodes?: string[] | null;
}): SessionBillingPayload => ({
  place_of_service: placeOfService ?? null,
  line_items: normalizeCptCodes(cptCodes).map(code => ({
    code_id: toCptCodeId(code),
  })),
});

export const getSessionBillingPlaceOfService = (
  value: SessionBillingCarrier | null | undefined,
): string | null => {
  const sessionBilling = getSessionBilling(value);
  if (sessionBilling) return sessionBilling.place_of_service ?? null;

  return value?.place_of_service ?? null;
};

export const getSessionBillingCptCodes = (
  value: SessionBillingCarrier | null | undefined,
): string[] => {
  const sessionBilling = getSessionBilling(value);
  if (sessionBilling) {
    return normalizeCptCodes(
      (sessionBilling.line_items ?? []).map(lineItem => lineItem?.code_id ?? ''),
    );
  }

  return normalizeCptCodes(value?.cpt_codes);
};

export const hasExplicitSessionBillingCptCodes = (
  value: SessionBillingCarrier | null | undefined,
): boolean => {
  const sessionBilling = getSessionBilling(value);
  if (sessionBilling) return true;

  return Array.isArray(value?.cpt_codes);
};
